module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step3@2x.f9af993f.png";